<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <rocket-link
            :language="form.language"
            v-model="form.link"
        />

        <media-reference
            v-model="form.icon"
            class="mt-3"
            label="* Icon"
            :media-types="['Icon']"
            name="icon_id"
            :error="errors.icon_id ? errors.icon_id[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
import RocketLink from "./Link/RocketLink";
import linkTypes from "../mixins/linkTypes";

export default {
    name: "CategoryTileForm",
    components: {RocketLink},
    mixins: [crudForm, linkTypes],
    data() {
        return {
            form: {
                link: this.getFormData("link", {}),
                icon_id: this.getFormData("icon_id"),
                icon: this.getFormData("icon"),
            },
        };
    },
    watch: {
        "form.icon": function(newValue){
            this.form.icon_id = newValue?.id || null;
        },
    }
}
</script>
